/*
 * Helpers for the product description, stored as a small HTML subset (bold, italic,
 * underline, paragraphs, line breaks, bullet / numbered / dash lists) sanitized by the
 * backend. Descriptions saved before the editor existed are plain text.
 */

const HAS_TAG = /<\/?[a-z][\s\S]*>/i;

const escapeHtml = (text) =>
  String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// value stored in the database -> html shown by the editor
export const toEditorHtml = (value) => {
  if (!value) return "";
  if (HAS_TAG.test(value)) return value;
  return String(value)
    .split(/\r?\n/)
    .map((line) => `<p>${escapeHtml(line) || "<br>"}</p>`)
    .join("");
};

// html of the editor -> plain text (empty check, previews)
export const stripHtml = (html) =>
  String(html || "")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/(p|li|div)>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim();

export const isEmptyHtml = (html) => stripHtml(html) === "";
